jQuery(function ($) {
    'use strict';

    var timeoutID;
    var $editions = $('.editions');

    $('.js-edition-button').on('click', openEditions);

    ////////////////

    function openEditions(e) {
        e.stopPropagation();
        clearAlert();

        if ($editions.hasClass('editions--open')) {
            closeEditions();
        } else {
            $(window).on('click', closeEditions);
            $editions.addClass('editions--open').hover(clearAlert, delayedAlert);
        }
    }

    function closeEditions(e) {
        $(window).off('click', closeEditions);
        $editions.removeClass('editions--open').off('mouseenter mouseleave');
    }

    function delayedAlert() {
        timeoutID = setTimeout(closeEditions, 1000);
    }

    function clearAlert() {
        clearTimeout(timeoutID);
    }

});